module.exports = __webpack_public_path__ + "img/sinteustatius.67f3ea0d.svg";